var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: "crud-sidemenu-container " + (!_vm.isActive ? "hidden" : ""),
      attrs: { id: "crud-sidemenu-container-for-labels" }
    },
    [
      _c("div", { staticClass: "crud-sidemenu-actions-wrapper" }, [
        _c("button", { on: { click: _vm.hideMenu } }, [
          _vm._v(_vm._s(_vm.$t("crudSideMenu.cancel")))
        ]),
        _c(
          "button",
          { staticClass: "with-backgound", on: { click: _vm.submitData } },
          [
            _vm._v(
              _vm._s(
                _vm.mode === "create"
                  ? _vm.$t("crudSideMenu.create")
                  : _vm.$t("crudSideMenu.update")
              )
            )
          ]
        )
      ]),
      _c(
        "div",
        { staticClass: "crud-sidemenu-content-wrapper" },
        [
          _vm.mode === "edit"
            ? _c("label", { staticClass: "static-content-label" }, [
                _vm._v(_vm._s(_vm.$t("crudSideMenu.id")))
              ])
            : _vm._e(),
          _vm.mode === "edit"
            ? _c("span", [_vm._v(_vm._s(_vm.elementId))])
            : _vm._e(),
          _c("CurdSelect", {
            attrs: {
              label: _vm.$t("crudSideMenu.status"),
              showLabel: true,
              id: "status",
              name: "status",
              placeholder: _vm.$t("crudSideMenu.selectStatus"),
              validationRules: { required: true },
              options: _vm.statusOptions,
              value: _vm.selectedStatus,
              isManagementListener: true
            },
            on: { valueHasChanged: _vm.selectStatus, hasError: _vm.hasError }
          }),
          _c("CrudInput", {
            class: `${
              _vm.$route.path.indexOf("/manage/content") > -1 ? "hidden" : ""
            }`,
            attrs: {
              id: "label",
              name: "name",
              placeholder: _vm.$t("crudSideMenu.addLabel"),
              type: "text",
              label: _vm.$t("crudSideMenu.label"),
              showLabel: true,
              hasCheckBox: false,
              validationRules: {
                required: true,
                max: 255
              },
              value: _vm.name,
              isManagementListener: true
            },
            on: { valueHasChanged: _vm.changeName, hasError: _vm.hasError }
          }),
          _c("CurdSelect", {
            class: `${
              _vm.$route.path.indexOf("/manage/content") > -1 ? "hidden" : ""
            }`,
            attrs: {
              label: _vm.$t("crudSideMenu.type"),
              showLabel: true,
              id: "type",
              name: "type",
              placeholder: _vm.$t("crudSideMenu.selectType"),
              validationRules: { required: true },
              options: _vm.typesOptions,
              value: _vm.selectedType,
              isManagementListener: true
            },
            on: { valueHasChanged: _vm.selectType, hasError: _vm.hasError }
          }),
          _vm.mode === "edit"
            ? _c("label", { staticClass: "static-content-label" }, [
                _vm._v(_vm._s(_vm.$t("crudSideMenu.projects")))
              ])
            : _vm._e(),
          _vm.mode === "edit"
            ? _c("span", [_vm._v(_vm._s(_vm.usages))])
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }